import { render } from "./NotFound.vue?vue&type=template&id=1c928059&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=1c928059&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-1c928059"

export default script